import { LogLevel, ProtocolMode, ServerResponseType } from "@azure/msal-browser";

const AppConfig = {
    baseApiUrl: process.env.REACT_APP_BaseApiUrl + '/api',
};



const MsalConfig = {
    auth: {
        clientId: process.env.REACT_APP_ClientId ?? '',
        authority: process.env.REACT_APP_Authority,
        knownAuthorities: [process.env.REACT_APP_Authority ?? ''],
        redirectUri: process.env.REACT_APP_RedirectUri,
        protocolMode: process.env.REACT_APP_ProtocolMode === "OIDC" ? ProtocolMode.OIDC : ProtocolMode.AAD,
        OIDCOptions: { serverResponseType: ServerResponseType.QUERY },
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "localStorage", // Da deluje "Single sign-out", mora biti določena vrednost "localStorage".
        storeAuthStateInCookie: false
    },
    system: {
        allowRedirectInIframe: true, // Da deluje "Single sign-out".
        loggerOptions: {	
            loggerCallback: (level: LogLevel, message: any, containsPii: any) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const LoginRequest = {
    //scopes: ["User.Read"]
    scopes: [process.env.REACT_APP_LoginScopes ?? '']
};

const AccessTokenRequest = {
    scopes: [process.env.REACT_APP_Scopes ?? '']
};

export default AppConfig;
export { MsalConfig, LoginRequest, AccessTokenRequest };